<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    @new-confirm-and-add-other-action="createEntryAndAddOther"
    :saveAndAddOtherButtonEnabled="true"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :stockAdjustment="stockAdjustment"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    stockAdjustment: Object,
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.loading = true;
      this.$apollo
        .query({
          query: NEW_STOCK_ADJUSTMENT_ITEM_QUERY,
          variables: {
            stockId: this.stockAdjustment.stockId
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // console.log("itens for stock adjustment", response);
          this.entry = response.data.accountContext.stockAdjustmentItem;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        this.$emit("entry-created", this.entry);
        this.resetForm();
        return true;
      } else {
        return false;
      }
    },
    createEntryAndAddOther: function() {
      if (this.createEntry()){
        this.loadServerEntry();
        this.$refs.baseNew.newDialog = true;
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const NEW_STOCK_ADJUSTMENT_ITEM_QUERY = gql `
query($stockId: ID!) {
  accountContext {
    stockAdjustmentItem {
      id
      quantity
      price
      isNewItemInStock
      itemId
      item {
        id
        name
        unit {
          id
          name
        }
      }
      packagingId
      packaging {
        id
        name
        text
        size
      }
      validations
    }
    availableItemsForStock(stockId: $stockId) {
      id
      name
      unit {
        id
        name
      }
      brand {
        id
        name
      }
      typeText
    }
  }
}
`;

</script>

<style scoped></style>
